export default "__VITE_ASSET__BvO4GsXD__"